import React from 'react';
import {useSelector} from 'react-redux';
import {RootState} from '~/redux/root-reducer';
import {FERTILITY_TEST_KEYS} from '~/constants/medical-questionnaires';
import Questionnaire1Screen from '~/pages/homes/fertility-test/Questionnaire1Screen';
import Questionnaire2Screen from '~/pages/homes/fertility-test/Questionnaire2Screen';
import Questionnaire3Screen from '~/pages/homes/fertility-test/Questionnaire3Screen';
import Questionnaire4Screen from '~/pages/homes/fertility-test/Questionnaire4Screen';
import Questionnaire5Screen from '~/pages/homes/fertility-test/Questionnaire5Screen';
import Questionnaire6Screen from '~/pages/homes/fertility-test/Questionnaire6Screen';
import {trackPageViewGA} from '~/services/google-analytics';

const FertilityTest = () => {
  const activeQuestion = useSelector((state: RootState) => state.questionnaires.activeQuestion);
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);

  const questionnaires = medicalQuestionnaire?.questionnaires;

  if (!questionnaires?.length) return null;

  const renderQuestion = () => {
    const keys = activeQuestion.keys;
    const key = keys[keys.length - 1];
    switch (key) {
      case FERTILITY_TEST_KEYS.START:
        trackPageViewGA('/fertility-test/start', 'MDQ-Fertility Test - Start');
        return <Questionnaire1Screen />;
      case FERTILITY_TEST_KEYS.PROFILE:
        trackPageViewGA('/fertility-test/profile', 'MDQ-Fertility Test - Profile');
        return <Questionnaire2Screen />;
      case FERTILITY_TEST_KEYS.INVALID:
        trackPageViewGA('/fertility-test/invalid', 'MDQ-Fertility Test - Invalid');
        return <Questionnaire3Screen />;
      case FERTILITY_TEST_KEYS.ON_BIRTH_CONTROL:
        trackPageViewGA('/fertility-test/on-birth-control', 'MDQ-Fertility Test - On Birth Control');
        return <Questionnaire4Screen />;
      case FERTILITY_TEST_KEYS.APPOINTMENT_PREFERENCES:
        trackPageViewGA('/fertility-test/appointment-preferences', 'MDQ-Fertility Test - Appointment Preferences');
        return <Questionnaire5Screen />;
      case FERTILITY_TEST_KEYS.YOUR_TEST_PACKAGE:
        trackPageViewGA('/fertility-test/your-test-package', 'MDQ-Fertility Test - Your Test Package');
        return <Questionnaire6Screen />;
      default:
        // eslint-disable-next-line no-console
        console.warn('Not implement yet!');
        return <Questionnaire1Screen />;
    }
  };

  return renderQuestion();
};

export default FertilityTest;
